import { TOP_NAV_MENU_LABEL } from '@/app/constants/top-navigation';
import type { NavMenuItemType } from '@/app/types/top-navigation';
import type { BaseDisplayConfigs } from '@/components/layouts/top-navigation/shared/menu-item/base';
import { Item } from '@/components/layouts/top-navigation/shared/menu-item/base/list/item';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import { Container } from '@/components/shared/layout/container';
import type { CSS } from '@/stitches.config';

const DESKTOP_TITLE = 'ดูข้อมูล';

export interface ListProps extends BaseDisplayConfigs {
  item: NavMenuItemType;
  hideTitle?: boolean;
  css?: CSS;
  onClose?: () => void;
}

export const List = ({
  item,
  isModelBuyingTools = false,
  isDesktop = false,
  hideTitle = false,
  css = {},
  onClose,
}: ListProps) => {
  const isBuyingToolsAndDesktop = isModelBuyingTools && isDesktop;
  const isBuyingToolsOrDesktop = isModelBuyingTools || isDesktop;
  const itemTitle = item.title ?? (isDesktop ? DESKTOP_TITLE : '');
  return (
    <Box
      display="flex"
      direction="column"
      rowGap={{ '@initial': 4, '@xl': isBuyingToolsAndDesktop ? 1 : 0 }}
      paddingLeft={isBuyingToolsAndDesktop ? 10 : undefined}
      aria-label={item.title ?? TOP_NAV_MENU_LABEL}
      component="nav"
      role="menubar"
      css={css}
    >
      {!hideTitle && !!itemTitle && (
        <Container
          size={isBuyingToolsOrDesktop ? 'none' : 'sm'}
          css={{
            '@xl': {
              mb: '$space-4',
            },
          }}
        >
          <Text
            size="text-base-2"
            css={{
              color: '#555555', // tailwind gray-700
            }}
          >
            {itemTitle}
          </Text>
        </Container>
      )}
      {item.children?.map((item, index) => (
        <Item
          key={`listitem${index}`}
          item={item}
          noContainer={isBuyingToolsOrDesktop}
          onClose={onClose}
        />
      ))}
    </Box>
  );
};
